var React = require('react');
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');
var Link = require('react-router').Link;
var PropTypes = require('prop-types');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var cookie = require('react-cookie');
var utils = require('../../../utils/utils');
var SubscribeForm = require('./subscribeForm.jsx');

var Home = createReactClass({
    mixins: [PureRenderMixin],

    getInitialState: function(){
        return {
            isUserPromisSurveyAlreadyTaked: false
        };
    },

    componentDidMount: function(){
        this.updateIsUserPromisSurveyAlreadyTakedState(this.props.latestScore);

        if(this.props.auth.token){
            this.props.fetchLatestScore(this.props.auth.token);
        }

        // Check for id in querystring and set externalId
        const { location } = this.props;
        if (location.query && location.query.id) {
            cookie.save('nhs_externalId', location.query.id);
        } else {
            cookie.remove('nhs_externalId');
        }        
    },

    componentWillReceiveProps: function(nextProps){
        if(nextProps.auth.user.id && nextProps.auth.user.id !== this.props.auth.user.id){
            this.props.fetchLatestScore(this.props.auth.token);
        }

        if(nextProps.latestScore.submissionId && nextProps.latestScore.submissionId !== this.props.latestScore.submissionId){
            this.updateIsUserPromisSurveyAlreadyTakedState(nextProps.latestScore);
        }
    },

    updateIsUserPromisSurveyAlreadyTakedState: function(latestScore){
        this.setState({
            isUserPromisSurveyAlreadyTaked: utils.isSurveyCompleted(latestScore)
        });
    },

	handleSubscribe: function(email) {
		this.props.signUp(email);
    },

    handleClickTracking: function(e) {
        var label = 'Home Page';
        var action = 'Click';
        this.props.recordDownloadClick(action, label);
    },

    handleSurveyClick: function(event){
        var target = event.target;
        var promisPathname = '/dashboard/surveys/promis';
        
        if(event.target.getAttribute('href') !== promisPathname){
            this.props.setLoginRedirectUrl(promisPathname);
        }

        if(target.innerText === 'Track again tomorrow'){
            this.props.showModal('MODAL_TYPE_PROMIS');
        }
        this.props.recordSurveyButtonClicked(target.innerText);
    },

    handleSurveyStart: function(event){
        event.preventDefault();
        var target = event.target;
        var surveyPathname = '/dashboard/surveys/nhs2';
        
        if(event.target.getAttribute('href') !== surveyPathname){
            this.props.setLoginRedirectUrl(surveyPathname);
        }

        /*
        if(target.innerText === 'Track again tomorrow'){
            this.props.showModal('MODAL_TYPE_PROMIS');
        } */
        this.props.recordSurveyButtonClicked(target.innerText);
        this.props.createGuestAccount(surveyPathname);
    },    

    render: function(){
        return (
			<div className="content fadeIn animated duration-750 delay-600">
          <Helmet
              title="National health survey"
              meta={[{
                  name: 'description',
                  content: 'Nationwide health survey studying the prevalence of various diseases in the population as a whole.'
              }]}
          />
			    <div id="hero-container">
			        <section id="hero">
			            <div className="row">
			                <div className="large-7 end small-12 column text-center">
                                <img
                                    className="hero-logo hide"
                                    src="https://res.cloudinary.com/mytotalhealth/image/upload/v1580450258/web/NH-2_Final.png"
                                    alt="Survey logo" />
                                <div className="home-copy">
    			                    <div className="fadeIn ease-in-out duration-1500 delay-500 animated" id="headline">
    			                        <div className="column">
    			                            <h1 className="text-center">We need your help to complete a large national health survey</h1>
    			                        </div>
    			                    </div>
    			                    <div className="description-wrapper">
                                        <p className="text-center">The data we gather from this survey will allow us to better understand the health of Americans and help pave the way for new treatments for various conditions</p>
                                        <p className="text-center"><button className="button large success" type="submit" onClick={this.handleSurveyStart}>Begin the Survey</button></p>
    			                    </div>
                                </div>
			                </div>

			            </div>
			        </section>
			    </div>
			    <div id="secondary" className="hide">
			        <section id="education">
			            <div className="row">
			                <div className="large-5 small-12 column">
			                    <div id="body">
			                        <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/male-transparent.png" alt="MyGiHealth Learning Center" title="MyGiHealth Learning Center" />
			                    </div>
			                </div>
			                <div className="headline large-5 small-12 column end">
			                    <h2>Understanding your symptoms is the first step toward feeling better.</h2>
			                    <p>The Learning Center empowers you with answers to the important questions you have about your Gi disorder.</p>
                                <p><Link to="/education" className="link button">Visit the Gi Learning Center</Link></p>
			                </div>
			            </div>
			        </section>
			    </div>
                <div className="usecases-wrapper hide">
                    <section id="usecases">
                        <div className="row collapse">
                            <div className="medium-6 column">
                                <div className="personal-use-case use-case">
                                    <h3>Personal Use <span>With Your Mobile Device</span></h3>
                                    <p className="description">Use our academically researched and validated tools to gain control over your symptoms. Assess, track, and compare your symptoms to benchmarks, and learn more about them from an Education Prescription&copy;.</p>
                                    <p className="text-center"><Link className="button success" to="/app">Personal Use</Link></p>
                                </div>
                            </div>
                            <div className="medium-6 column end">
                                <div className="clinical-use-case use-case">
                                    <h3>Clinical Use <span>Connecting Healthcare Professionals To Patients</span></h3>
                                    <p className="description">Working with experts in patient communication and computing technology, doctors at Cedars-Sinai, the University of Michigan and UCLA have re-engineered the role of technology in clinical practice.</p>
                                    <p className="text-center"><Link className="button" to="/clinical-use">Clinical Use</Link></p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
			    <div id="tertiary" className="hide">
			        <section id="newsletter" name="newsletter">
			            <div className="row">
			                <div className="headline large-5 small-12 large-offset-1 column">
								<p>Sign up for email updates and get early access to our latest products, features & tools!</p>
			                </div>
			                <div className="large-6 small-12 column end">
			                    <div id="sign-up">
		                        	<SubscribeForm
                                        newsletter={this.props.newsletter}
                                        subscribe={this.handleSubscribe}
                                        clearError={this.props.clearNewsletterError} />
		                            <p>Your email is safe with us!  We will never give your information to a third party. You can expect about one email per month.</p>
			                    </div>
			                </div>
			            </div>
			        </section>
			    </div>
                <div className="about-wrapper hide">
			        <section id="about">
			            <div className="row">
			                <div className="medium-7 medium-centered small-12 column">
			                    <h2>About MyGiHealth</h2>
                                <p>My Total Health was founded to enable patients to monitor, manage, and understand their symptoms for a range of conditions. MyGiHealth is the first of a pipeline of novel health applications created by the team.</p>
                                <p className="text-center"><Link className="button secondary" to="/about">Meet the Team</Link></p>
                            </div>
			            </div>
			        </section>
			    </div>
			    <div id="preload" className="hide">
			        <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/mygihealth-app-dashboard-v3.png" alt="" />
			    </div>
			</div>
        )
    }
});

Home.contextTypes = {
  router: PropTypes.object.isRequired
};

module.exports = Home;



// WEBPACK FOOTER //
// ./src/common/routes/home/components/home.jsx